import { initialRouterState } from '../router/router-state';
import { initialToastState } from '../toast/toast.state';

export interface IAppState {
  [key: string]: any   
}

const initialState: IAppState = {
  toast: initialToastState(), 
  router: initialRouterState()
}

export function initialAppState() {
  return { ...initialState };
}

